import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { flows } from '@/helpers/APIconnection';
import { FlowDetailsController } from '@/components/FlowDetails.vue';
export default {
  data: function () {
    return {
      expanded: [],
      FlowDetailsController,
      headers: [{
        title: 'Robot y lanzamiento',
        align: 'start',
        key: 'robot',
        sortable: false
      }, {
        title: 'Fecha y hora',
        align: 'start',
        key: 'createdAtString',
        width: 150
      }, {
        title: 'Resultado',
        align: 'center',
        key: 'result',
        sortable: false
      }, {
        title: 'Coste',
        align: 'center',
        key: 'cost',
        sortable: false
      }, {
        title: '',
        key: 'button',
        sortable: false,
        width: 0,
        align: 'center'
      }],
      query: {
        sortby: 'createAt',
        sortdir: 'desc',
        page: 1,
        limit: 12,
        isScheduled: 0
      },
      logs: undefined,
      stats: undefined,
      loading: {},
      today: new Date().setHours(0, 0, 0, 0)
    };
  },
  created() {
    this.GetFlowHistory();
    this.$state.OnAutopilotExecution = this.GetFlowHistorial;
  },
  unmounted() {
    this.$state.OnAutopilotExecution = undefined;
  },
  computed: {
    Query() {
      return {
        ...this.query
      };
    } // used to fix reactive problems with watcher
  },
  watch: {
    Query: {
      handler(oldValue, newValue) {
        if (oldValue.isScheduled !== newValue.isScheduled && this.query.page !== 1) {
          this.query.page = 1;
          return;
        }
        this.GetFlowLogs();
      },
      deep: true
    }
  },
  methods: {
    GetFlowHistory: function () {
      this.GetFlowLogs();
      this.GetFlowLogsStats();
    },
    GetFlowLogs: async function () {
      if (this.loading.flowLogs) return;
      this.loading.flowLogs = true;
      const {
        sortby,
        sortdir,
        page,
        limit,
        isScheduled
      } = this.query;
      let queryString = `?sortby=${sortby}&sortdir=${sortdir}&start=${(page - 1) * limit}&limit=${limit}`;
      if (isScheduled === 1) {
        queryString += '&scheduled=false';
      } else if (isScheduled === 2) {
        queryString += '&scheduled=true';
      }
      const response = await flows.getLogs(queryString);
      if (response?.status === 200 && response.data) {
        response.data.items = Object.values(response.data.items);
        const today = new Date().setHours(0, 0, 0, 0);
        const yesterday = new Date().setHours(-24, 0, 0, 0);
        response.data.items.forEach(item => {
          item.expanded = true;
          FlowDetailsController.NormalizeLogData(item);
          const createdAt = new Date(item.createAt).setHours(0, 0, 0, 0);
          if (createdAt === today) {
            item.createdAtString = 'Hoy a las ' + this.$formatDate({
              date: item.createAt,
              format: 'hh:mm'
            });
          } else if (createdAt === yesterday) {
            item.createdAtString = 'Ayer a las ' + this.$formatDate({
              date: item.createAt,
              format: 'hh:mm'
            });
          }
          return item;
        });
        this.logs = response.data;
      }
      this.loading.flowLogs = false;
    },
    GetFlowLogsStats: async function () {
      const response = await flows.getLogsStats();
      if (response?.status === 200 && response.data) {
        this.stats = response.data;
      }
    },
    GetFlowLogsReport: async function () {
      this.loading.logReport = true;
      const response = await flows.getLogsReport(this.filtersAsString ? '?' + this.filtersAsString : '');
      if (response?.status === 200) {
        this.$download({
          blob: new Blob([Buffer.from(response.data, "base64")], {
            type: "application/vnd.ms-excel"
          }),
          filename: "reporteSlango.xlsx"
        });
      }
      this.loading.logReport = false;
    }
  }
};